import { PhotoSettings as PhotoSettingsModule } from "../modules/PhotoSettings/PhotoSettings";

const PhotoSettings = () => {
  return <PhotoSettingsModule />;
};

export default PhotoSettings;
